export default [
  {
    component: 'CNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
    badge: {
      color: 'primary',
      text: 'Principal',
    },
  },
  /* {
    component: 'CNavGroup',
    name: 'Cadastros Gerais',
    icon: 'cil-list',
    items: [
      {
        component: 'CNavItem',
        name: 'Cliente',
        to: '/cliente',
      },
      {
        component: 'CNavItem',
        name: 'Banco',
        to: '/banco',
      },
      {
        component: 'CNavItem',
        name: 'Classe',
        to: '/classe',
      },
      {
        component: 'CNavItem',
        name: 'Genero',
        to: '/genero',
      },
      {
        component: 'CNavItem',
        name: 'Atividade',
        to: '/atividade',
      },
      {
        component: 'CNavItem',
        name: 'Produto',
        to: '/produto',
      },
      {
        component: 'CNavItem',
        name: 'Crm_contato',
        to: '/crm_contato',
      },
      {
        component: 'CNavItem',
        name: 'Crm_contato_setor',
        to: '/crm_contato_setor',
      },
      {
        component: 'CNavItem',
        name: 'Cat-defeito',
        to: '/cat_defeito',
      },
      {
        component: 'CNavItem',
        name: 'Cat-equipamento',
        to: '/cat_equipamento',
      },
      {
        component: 'CNavItem',
        name: 'Cat-parametros',
        to: '/cat_parametros',
      },
      {
        component: 'CNavItem',
        name: 'Cat-situacao',
        to: '/cat_situacao',
      },
      {
        component: 'CNavItem',
        name: 'Cat-tipo',
        to: '/cat_tipo',
      },
      {
        component: 'CNavItem',
        name: 'Est-anp',
        to: '/est_anp',
      },
      {
        component: 'CNavItem',
        name: 'Est-grupo',
        to: '/est_grupo',
      },
      {
        component: 'CNavItem',
        name: 'Est-ncm',
        to: '/est_ncm',
      },
    ],
  },
  {
    component: 'CNavGroup',
    name: 'Pedidos',
    icon: 'cil-list',
    items: [
      {
        component: 'CNavItem',
        name: 'Pedido',
        to: '/pedido',
      },
    ],
  },
  {
    component: 'CNavGroup',
    name: 'Estoque',
    icon: 'cil-list',
    items: [
      {
        component: 'CNavItem',
        name: 'Produto',
        to: '/produto',
      },
      {
        component: 'CNavItem',
        name: 'Grupo',
        to: '/grupo',
      },
      {
        component: 'CNavItem',
        name: 'NCM',
        to: '/ncm',
      },
      {
        component: 'CNavItem',
        name: 'ANP',
        to: '/anp',
      },
    ],
  }, */
  {
    component: 'CNavGroup',
    name: 'Módulo Campanha',
    icon: 'cil-list',
    items: [
      {
        component: 'CNavItem',
        name: 'Campanhas',
        to: '/campanhas',
      },
      {
        component: 'CNavItem',
        name: 'Distribuidores',
        to: '/distribuidores',
      },
      {
        component: 'CNavItem',
        name: 'Condições de Pagamento',
        to: '/condpgtos',
      },
    ],
  },
]
